import { Component, Input } from '@angular/core';

@Component({
  selector: 'getm-bottom-helper-card',
  templateUrl: './bottom-helper-card.component.html',
  styleUrls: ['./bottom-helper-card.component.scss'],
})
export class BottomHelperCardComponent {

  @Input() variant: 'info' | 'warning' = 'warning';
  @Input() icon?: string;
  @Input() description: string = '';
  @Input() count?: string | number;


}
